import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { Chip } from "@mui/material";

import { useTranslation } from "@/translations";

interface Props {
  isClient: boolean;
}

export function ClientBadge({ isClient }: Props) {
  const { t } = useTranslation();

  return (
    <Chip
      size="small"
      variant="outlined"
      color={isClient ? "primary" : "default"}
      icon={<FiberManualRecordIcon sx={{ fontSize: 10 }} />}
      label={isClient ? t("edicts.badge.isClient") : t("edicts.badge.notClient")}
    />
  );
}
